import {
  FlexColumn,
  IconCallout,
  ModalBody,
  ModalFooter,
  TextBody,
  TextHeading,
} from "@opensea/ui-kit"
import type { ComponentType, ReactNode } from "react"

type FeesContentLayoutProps = {
  icon: ComponentType<{ className?: string }>
  title: ReactNode
  body: ReactNode
  walletStatus?: ReactNode
  footer: ReactNode
}

export function FeesContentLayout({
  icon: Icon,
  title,
  body,
  walletStatus,
  footer,
}: FeesContentLayoutProps) {
  return (
    <>
      <ModalBody className="py-6 text-center">
        <FlexColumn className="items-center gap-6">
          <FlexColumn className="items-center gap-2">
            <IconCallout icon={Icon} size={24} variant="outlined" />

            <TextHeading size="md">{title}</TextHeading>
            <TextBody color="text-secondary" size="md">
              {body}
            </TextBody>
          </FlexColumn>

          {walletStatus}
        </FlexColumn>
      </ModalBody>
      <ModalFooter>{footer}</ModalFooter>
    </>
  )
}
